import { createContext } from 'react';
import type { SquareInfo } from "@/components/Game/GameGrid/GameGrid";

type GridContextType = {
    grid: SquareInfo[][];
    setGrid: React.Dispatch<React.SetStateAction<SquareInfo[][]>>;
    gamePackId: string;
    gameSessionId: string;
    treasureCount: number;
  };

export const GridContext = createContext<GridContextType | undefined>(undefined);
